export const CUSTOM_IMAGE_HANDLER_TEXTS = {
  ADD_TRUST_MARKERS_TITLE: "Add custom trust markers",
  TOOLTIP_DESC:
    "You can add self-designed trust markers in place of default markers. Simply upload them here. See reference",
  DESCRIPTION_TEXT:
    "You can add self-designed trust markers in place of default markers. Simply upload them here. ",
  SEE_REFERENCE: "See reference",
  TRUST_MARKERS_REF_TITLE: "Trust Markers",
  TRUST_MARKERS_REF_DESC:
    "Trust markers are present on your offering pages. They build credibility, reassure visitors about the site's legitimacy and encourage actions like purchases.",
  HOVER_TEXT: "Upload Image",
  QUERY: "trust markers",
  RECOMMENDED_FORMAT: "*Recommended format: 300 x 66 pixels (PNG or JPG)",
  UPLOAD_MARKER_ICON: "uploadmarker.svg",
  TOOLTIP_ID_IMAGES: "images",
  TRUST_MARKER_MODAL_ID: "trust_markers",
  TRUST_MARKER_REF_URL_1: "assets/vectors/homepage/trust1.png",
  TRUST_MARKER_REF_URL_2: "assets/vectors/homepage/trust2.png",
  TRUST_MARKER_MODAL_HEIGHT: "tw-h-[75px]",
  TRUST_IMG_KEY_1: "trust_img_1",
  TRUST_IMG_KEY_2: "trust_img_2",
  TRUST_IMG_KEY_3: "trust_img_3",
};

export const SECTION_TYPES = {
  WEBPAGE: "webpage",
  OFFERINGS: "offerings",
};
